import {
  setEnabled,
  setType,
  setFromAndTo,
  setIsInitialized,
  clear
} from './actions';

import { 
	thunkSetFromAndTo,
  thunkSetType,
  thunkSetEnabled,
  thunkClear,
  thunkLoadStateFromUrl,
 } from './thunks.core';

import {
	thunkToggleDateRange,
	thunkSetDateRangeTypeFromList,
	thunkFilterDateRange
} from './thunks.ui';

export {
	// PURE ACTION CREATORS
	setEnabled,
	setType,
  setFromAndTo,
  setIsInitialized,
  clear,

	// THUNKS
	thunkSetFromAndTo,
  thunkSetType,
  thunkSetEnabled,
  thunkClear,
  thunkLoadStateFromUrl,
	thunkToggleDateRange,
	thunkSetDateRangeTypeFromList,
	thunkFilterDateRange
};

export default {
	// PURE ACTION CREATORS
	setEnabled,
	setType,
  setFromAndTo,
  setIsInitialized,
  clear,

	// THUNKS
	thunkSetFromAndTo,
  thunkSetType,
  thunkSetEnabled,
  thunkClear,
  thunkLoadStateFromUrl,
	thunkToggleDateRange,
	thunkSetDateRangeTypeFromList,
	thunkFilterDateRange
};
